import React from "react";
import "./CognexLogo.css";

const CognexLogo = () => {
    return <span className="cognex-span">DoAssist</span>;
};

export default CognexLogo;